module.exports = __webpack_public_path__ + "static/media/ourpractice.2ecd1722.png";